module.exports = __webpack_public_path__ + "static/media/ICICI-Prudential.58220c03.png";